import { createSlice } from '@reduxjs/toolkit';

const initialListRowUploadsState = {
    uploadedFilesList: [],
}

const listRowUploadsSlice = createSlice({
    name: 'listRowUploads',
    initialState: initialListRowUploadsState,
    reducers: {
        pushFileToList(state, actions) {
            state.uploadedFilesList.push(actions.payload);
        },
        updateFileInList(state, actions) {
            let fIndex = state.uploadedFilesList.findIndex(f => f.id === actions.payload.id);
            if (fIndex >= 0) {
                state.uploadedFilesList[fIndex][actions.payload.fieldName] = actions.payload.FieldValue;
            }
        },
        resetFilesList(state) {
            state.uploadedFilesList = [];
        }
    }
});

export const listRowUploadsActions = listRowUploadsSlice.actions;
export default listRowUploadsSlice;